import React from 'react';

import { CardContent } from './CardContent';

interface Props extends React.HTMLAttributes<HTMLDivElement> {}

export const CardHeader: React.FC<React.PropsWithChildren<Props>> = (props) => (
  <CardContent header {...props} />
);
